import { Component, Injectable, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/primeng';
import { Location } from '@angular/common';
import { Subject } from 'rxjs/Rx';
import { EvsStampService } from '../../../../common/services/EvsStamp.service';
import { PagerService } from '../../../../common/services/Pagination.service';
import { DownloadExcelService } from '../../../../common/services/DownloadExcel.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { EvsErr } from '../evsErr';
import * as _ from 'lodash';
import * as moment from 'moment';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { environment } from '../../../../../environments/environment';
import { IOption } from 'ng-select';
import { EvsProductService } from '../../../../common/services/EvsProduct.service';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from '../../../imageService';
import { UploadService } from '../../../../common/services/Upload.service';
import { ExportService } from '../../../../common/services/Export.service';
import { BoxStampDistributionService } from '../../qrcode/share/boxStampDistribution/services/boxStampDistribution.service';
import { UploadEvsService } from '../../../../common/services/UploadEvs.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'evs-logs-stamp-for-guarantee',
  templateUrl: './log-guarantee-list-detail.template.html',
  styleUrls: ['./log-guarantee.component.css'],
  providers: [
    ConfirmationService,
    EvsStampService,
    DownloadExcelService,
    EvsProductService,
    BoxStampDistributionService
  ],
})
@Injectable()
export class LogsGuaranteeComponent implements OnInit {
  @ViewChild('lgModal') lgModal: ModalDirective;
  // @ViewChild('lgModal') lgModal: ModalDirective;
  @ViewChild('validateDownloadExcelPopup') validateDownloadExcelPopup: ModalDirective;
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  displayBasic: boolean;
  modalRef: any;
  listProducts: Array<IOption> = [];
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage = 1;
  public activeMainTab: string = 'list';
  goToListTab() {
    this.activeMainTab = 'list';
  }
  public totalRow = 0;
  public page_size = 10;
  public pager: any = {};
  public message: { class: string; content: string } = null;
  public msgs: Message[] = [];
  public error = '';
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public logs: any = [];
  has_list = false;
  cities: any;
  districts: any;
  type_list: any = [
    'Kích hoạt',
    'Tiếp nhận',
    'Hoàn thành',
    'Từ chối',
    'Thay đổi thông tin',
    'Chờ xử lý',
  ];
  types: any = ['Quét mã phủ cào', 'Quét theo Serial', 'Nhắn tin SMS'];
  typeValues: any = ['qri', 'serial', 'sms'];
  public showMoreFilter = true;

  public current_filter: any = {};
  start = 0;
  limit = 10;

  public item_active: any = 0;
  public logs_of_serial: any = [];
  public serial_info: any = {};
  public agency_info: any = {};
  public warrantyReminderConfig: any = null;
  public update_permission;
  selectedLogForAction: any = null;

  loading_data = true;

  isNote: Boolean = false;
  isAdd: Boolean = false;
  isSorting: any;

  totalItem: any = 0;
  totalPage: any = 0;
  serial: any;
  status: any = {};
  stasitic: any;
  waitPage = false;

  bsModalDownload: BsModalRef;
  bsModalValidateDownloadExcelPopup: BsModalRef;


  // add note to guarantee
  guarantee_note = '';
  guarantee_title_dialog = '';

  searchProductQuery = '';
  tmpCountBottom = 0;
  listField;
  cusomerUpdate = {};
  fields_list: any = [];
  form_control_fields: any = {};
  FormGuarantee: FormGroup;
  typeField = {};
  typeName = {};
  listRequire = [];
  imagesFields: any = {};
  imagesFieldsBoxStamp: any = {};
  source = Number(JSON.parse(localStorage.getItem('User')).source)
  limitProd = 10;
  offsetProd = 0;
  // getListFields() {
  //   this.stampService
  //     .getFieldGuarantee({limit: 100})
  //     .toPromise()
  //     .then((res: any) => {
  //       if (!res.error) {
  //         for (let i = 0; i < res.data.length; i++) {
  //           res.data[i].keyView = this.formatKey(res.data[i].key);
  //
  //           if (res.data[i].status) {
  //             this.fields_list.push(res.data[i]);
  //           }
  //         }
  //         console.log('this.fields_list', this.fields_list);
  //
  //         this.choiceActive();
  //         // this.createFormGuarantee(this.fields_list);
  //       } else {
  //         console.log('getListFields:error', res);
  //       }
  //     })
  //     .catch((err: any) => {
  //       console.log('getFieldGuarantee:catch', err);
  //     });
  // guarantee add note inprogress
  isShowNoteInProgressDialog = false;
  //   this.FormGuarantee = this.fb.group(controls);
  NoteInProgressPageSize = 3;

  // createFormGuarantee(list?: any) {
  //   let controls = {
  //     store_id: [null, Validators.required],
  //     print: [true],
  //   };
  //
  //   for (let field of list) {
  //     if (field.type == 'checkbox') {
  //       /*XU ly checkbox*/
  //       controls[field.key] = this.buildFormCheckbox(field.value, field);
  //     } else {
  //       controls[field.key] = [
  //         null,
  //         field.require ? Validators.required : null,
  //       ];
  //     }
  //   }
  //   this.form_control_fields = controls;
  /**
   * tuanba 9/5/2022: button Kích hoạt tem thùng
   */
  // openActiveTemp
  infoActiveBoxStamp: any = {};
  // tuanba 5/9/2022: Kích hoạt tem thùng.
  public errMsg = '';
  productId: any = null;
  // xử lí thêm note cho tiếp nhận/từ chối bảo hành
  status_guarantee: any = null;
  listFieldGuarantee: string[];
  imagesNoteInProgress: any = [];
  noteInProgress: any = {};
  currentLogId: string;
  // openActiveTemp
  infoActive: any = {};

  // choiceActiveBoxStamp() {
  //   // this.status = 1;
  list_districtActive: Array<IOption> = [];
  infoChange: any = {};
  infoReceive: any = {};
  countries: Array<IOption> = [];
  list_city: Array<IOption> = [];
  // selectedCountry: any = '241';
  selectedCityId;
  selectedDistrictId;
  infoChangeBoxStamp: any = {};
  infoReceiveBoxStamp: any = {};

  // getDetailVariantById(idProduct: any, variantId: any) {
  //   return this.productService
  //     .getDetailVariantById(idProduct, variantId)
  //     .toPromise()
  //     .then((res) => {
  //       if (!res.error && res.data) {
  //         let obj = {
  //           extra: res.data.extra,
  //           image: res.data.image,
  //         };
  //         return obj;
  //       } else {
  //         return null;
  //       }
  //     });
  // }
  // }
  countriesBoxStamp: Array<IOption> = [];
  listFieldBoxStamp;
  cusomerUpdateBoxStamp = {};
  listRequireBoxStamp = [];
  public errMsgAlertSingleStamp = '';
  public errMsgAlertBoxStamp = '';
  /** Tuanba:17-11-2022: Thay api xuất báo cáo **/
  public messageExport = '';
  public qri_serial_detail: any;

  /** Tuanba:17-11-2023: Hiện thị phường xã cho doanh nghiệp Darling **/
  public checkWard: any;

  constructor(
    private _location: Location,
    private router: Router,
    private stampService: EvsStampService,
    private pagerService: PagerService,
    private activatedRoute: ActivatedRoute,
    private productService: EvsProductService,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    private imageService: ImageService,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private upload: UploadService,
    private upload2: UploadEvsService,
    private exportService: ExportService,
    private boxStampDistributionService: BoxStampDistributionService,
    private translate: TranslateService
  ) {
    this.showMoreFilter = true;

    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
  }

  updateTranslations() {
    setTimeout(() => {
      const distributionAgent = $('#distributionAgent');
      distributionAgent.select2({
        placeholder: this.translate.instant('DAI_LY') || 'Đại lý',
        allowClear: true,
        ajax: {
          delay: 500,
          url: `${environment.qrcode_url}/agencies/search/guarantee/children`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
            'Content-Type': 'application/json',
          },
          dataType: 'json',
          data: function (params) {
            console.log('params11', params);
            if (params.term) {
              return {
                name: params.term,
                page: 1,
                pageSize: 10,
              };
            }
            return {
              page: 1,
              pageSize: 10,
            };
          },
          // tslint:disable-next-line:no-shadowed-variable
          processResults: (data) => {
            return {
              results: data.data.items.map((item) => {
                if (item.code) {
                  return {
                    text: item.name + '-' + item.code,
                    id: item.id,
                  };
                } else {
                  return {
                    text: item.name,
                    id: item.id,
                  };
                }
              }),
            };
          },
        },
      });

      $('#status').select2({ placeholder: this.translate.instant('TRANG_THAI') || 'Trạng thái', allowClear: false });
      $('#type').select2({ placeholder: this.translate.instant('KIEU_QUET') || 'Kiểu quét', allowClear: false });

      $('#_province').select2({ placeholder: this.translate.instant('CHON_TINHTP') || 'Chọn Tỉnh/TP', allowClear: false });
      $('#_district').select2({ placeholder: this.translate.instant('CHON_QUANHUYEN') || 'Chọn Quận/Huyện', allowClear: false });
    }, 50);
  }

  // }
  deleteImageFields(id, fieldKey) {
    for (let i = 0; i < this.imagesFields[fieldKey].length; i++) {
      if (this.imagesFields[fieldKey][i].id === id) {
        this.imagesFields[fieldKey].splice(this.imagesFields[fieldKey].indexOf(this.imagesFields[fieldKey][i]), 1);
        break;
      }
    }
  }

  tusUploadFields = (item, fieldKey) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = res.data.url;
            if (this.imagesFields[fieldKey].length >= 5) {
              this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.imagesFields[fieldKey].push(image2);
            }
          }
        });
      }
    }
  };

  checkSplit(e) {
    console.log('e', e)
    if (e && e.length > 0) {
      return e.join('')
    } else {
      return ''
    }
  }

  choiceActive() {
    // this.status = 1;
    console.log('ngan beo');
    this.cusomerUpdate = {}
    this.listRequire = []
    this.cusomerUpdate['nameField'] = {}
    this.cusomerUpdate['fields'] = {}
    this.stampService.getFieldGuaranteeCustomes().subscribe((res) => {
      if (res.data.length > 0) {
        this.listField = res.data;
        console.log('this.listField', this.listField)
        this.listField.map((val) => {
          this.typeField[val.key] = val.type
          this.typeName[val.key] = val.name
          if (val.require === 1 && val.status === 1) {
            this.listRequire.push(val.key)
          }
          this.cusomerUpdate['nameField'][val.key] = val.name


          if (val.type === 'checkbox') {
            this.cusomerUpdate['fields'][val.key] = {}
            val.value_f.map((n) => {
              this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
            })
          }
          if (val.type === 'image') {
            this.imagesFields[val.key] = []
            this.cusomerUpdate['fields'][val.key] = []
            console.log('this.imagesFields', this.imagesFields)
          }


          if (this.infoActive.fields && this.infoActive.fields.length > 0 && this.infoActive.fields !== null) {
            this.infoActive.fields.map((item) => {
              if (item.key === val.key) {
                if (val.type === 'date') {
                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                } else if (val.type === 'checkbox') {
                  this.cusomerUpdate['fields'][val.key] = {}
                  val.value_f.map((n) => {
                    if (item.string_values.split(',').includes(String(n.id))) {
                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                    }
                  })
                } else if (val.type === 'image') {
                  this.imagesFields[val.key] = item.string_values === null ? [] : item.string_values
                } else {
                  this.cusomerUpdate['fields'][val.key] = item.string_values
                }
              }

            })

          }
          console.log('this.cusomerUpdate', this.cusomerUpdate)
        })
      }

    });

  }

  deleteImageFieldsBoxStamp(id, fieldKey) {
    for (let i = 0; i < this.imagesFieldsBoxStamp[fieldKey].length; i++) {
      if (this.imagesFieldsBoxStamp[fieldKey][i].id === id) {
        this.imagesFieldsBoxStamp[fieldKey].splice(this.imagesFieldsBoxStamp[fieldKey].indexOf(this.imagesFieldsBoxStamp[fieldKey][i]), 1);
        break;
      }
    }
  }

  tusUploadFieldsBoxStamp = (item, fieldKey) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {

        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = res.data.url;
            if (this.imagesFieldsBoxStamp[fieldKey].length >= 5) {
              this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.imagesFieldsBoxStamp[fieldKey].push(image2);
            }
          }
        });
      }
    }
  };

  // hàm này không dùng nữa
  // updateStatus(status, i) {
  //   let statusString = "";
  //   switch (status) {
  //     case 3: {
  //       statusString = "hoàn thành bảo hành";
  //       break;
  //     }
  //     case 4: {
  //       statusString = "từ chối bảo hành";
  //       break;
  //     }
  //   }

  //   this.confirmationService.confirm({
  //     message:
  //       "Bạn chắc chắn muốn chuyển sang trạng thái " +
  //       statusString +
  //       " không ?",
  //     header: "Xác nhận",
  //     icon: "",
  //     accept: () => {
  //       // console.log(this.logs_of_serial[i]);
  //       console.log(i, status);
  //       return;
  //       this.stampService
  //         .updateGuaranteeStatusById(this.logs_of_serial[i].id, status)
  //         .subscribe((res) => {
  //           if (!res.error) {
  //             this.toastr.info(
  //               "Đã chuyển trạng thái sang " + statusString,
  //               "",
  //               {
  //                 timeOut: 4000,
  //                 positionClass: "toast-bottom-right",
  //               }
  //             );
  //             this.viewDetail(this.serial_info.serial, this.item_active);
  //           }
  //         });
  //     },
  //   });
  // }

  choiceActiveBoxStamp() {
    // this.status = 1;
    console.log('ngan beo');
    this.cusomerUpdateBoxStamp = {}
    this.listRequireBoxStamp = []
    this.cusomerUpdateBoxStamp['nameField'] = {}
    this.cusomerUpdateBoxStamp['fields'] = {}
    this.stampService.getFieldGuaranteeCustomes().subscribe((res) => {
      if (res.data.length > 0) {
        this.listFieldBoxStamp = res.data;
        console.log('this.listField', this.listField)
        this.listFieldBoxStamp.map((val) => {
          this.typeField[val.key] = val.type
          this.typeName[val.key] = val.name
          if (val.require === 1 && val.status === 1) {
            this.listRequireBoxStamp.push(val.key)
          }
          this.cusomerUpdateBoxStamp['nameField'][val.key] = val.name


          if (val.type === 'checkbox') {
            this.cusomerUpdateBoxStamp['fields'][val.key] = {}
            val.value_f.map((n) => {
              this.cusomerUpdateBoxStamp['fields'][val.key][`check${n.id}`] = false
            })
          }
          if (val.type === 'image') {
            this.imagesFieldsBoxStamp[val.key] = []
            this.cusomerUpdateBoxStamp['fields'][val.key] = []
            console.log('this.imagesFields', this.imagesFieldsBoxStamp)
          }
          if (this.infoActiveBoxStamp.fields && this.infoActiveBoxStamp.fields.length > 0 && this.infoActiveBoxStamp.fields !== null) {
            this.infoActiveBoxStamp.fields.map((item) => {
              if (item.key === val.key) {
                if (val.type === 'date') {
                  this.cusomerUpdateBoxStamp['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                } else if (val.type === 'checkbox') {
                  this.cusomerUpdateBoxStamp['fields'][val.key] = {}
                  val.value_f.map((n) => {
                    if (item.string_values.split(',').includes(String(n.id))) {
                      this.cusomerUpdateBoxStamp['fields'][val.key][`check${n.id}`] = String(n.id)
                    }
                  })
                } else if (val.type === 'image') {
                  this.imagesFieldsBoxStamp[val.key] = item.string_values === null ? [] : item.string_values
                } else {
                  this.cusomerUpdateBoxStamp['fields'][val.key] = item.string_values
                }
              }
            })
          }
          console.log('this.cusomerUpdateBoxStamp', this.cusomerUpdateBoxStamp)
        })
      }

    });

  }

  formatKey(str) {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    // Some system encode vietnamese combining accent as individual utf-8 characters
    // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
    str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
    str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
    // Remove extra spaces
    // Bỏ các khoảng trắng liền nhau

    str = str.trim();
    // Remove punctuations
    // Bỏ dấu câu, kí tự đặc biệt
    str = str.replace(
      /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
      ' '
    );
    str = str.replace(/ + /g, ' ');
    str = str.replace(/\s/g, '');
    return str;
  }

  guaranteeActive() {
    console.log('12312312')
    this.isAdd = true;
    this.isNote = false;
    if (this.logs[this.item_active]) {
      this.router.navigate(['/evs/guarantee/add'], {
        queryParams: { serial: this.logs[this.item_active].serial },
      });
    } else {
      this.router.navigate(['/evs/guarantee/add']);
    }
    //this.lgModal.show();
  }

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('User'));
    const wardBussiness = environment.wardBussiness
    if (user) {
      this.checkWard = wardBussiness.includes(user.id)
    }
    console.log('uerrsasd', user)
    this.lgModal.onHide.subscribe(() => {
      this.isAdd = false;
    });
    this.activatedRoute.params.forEach((params: Params) => {
      const serial = params.serial;
      if (serial) {
        this.model.serial = serial;
      }
    });
    // $('#service').select2({ placeholder: "-- Chọn dịch vụ --", allowClear: true });
    // $('#type').select2({ placeholder: "-- Lọc trạng thái --", allowClear: true });
    // $('#inputStart').datepicker({ format: 'dd-mm-yyyy' });
    // $('#inputEnd').datepicker({ format: 'dd-mm-yyyy' });
    // $('.input-daterange').datepicker();
    this.updateTranslations();

    const that = this;
    $('#_province')
      .on('select2:select', function (e) {
        $('.select2-selection__rendered').removeAttr('title');
        const id = e.target.value;
        that.loadDistrictData(id);
      });
    $('#_district')
      .on('select2:select', function () {
        $('.select2-selection__rendered').removeAttr('title');
      });
    $('#status')
      .on('select2:select', function () {
        $('.select2-selection__rendered').removeAttr('title');
      });
    $('#type')
      .on('select2:select', function () {
        $('.select2-selection__rendered').removeAttr('title');
      });
    // this.getCountries();
    this.getCity();
    this.getStasitic();
    // this.getListProduct();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.isSorting = 'desc';
      if (params.serial) {
        this.model.serial = params.serial;
      }
      if (params.sms || params.code) {
        this.model.sms = params.sms || params.code;
      }
      if (params.phone) {
        this.model.phone = params.phone;
      }
      if (params.batch_id && params.status) {
        this.current_filter.batch_id = params.batch_id;
        this.current_filter.status = params.status;
        $('#status').val(params.status).trigger('change');
        this.loadData(this.current_filter, this.isSorting);
      } else {
        this.onSubmit();
      }
    });
    //this.loadData(this.current_filter, 'desc');
    // this.choiceActive();
    // this.getListFields();

  }

  // }
  buildFormCheckbox(list_checkboxs, field) {
    const arr: any = [];
    for (const k in list_checkboxs) {
      if (list_checkboxs[k].isVisible) {
        arr.push(this.fb.control(false));
      }
    }
    // console.log(arr);
    return this.fb.array(arr, field.require ? Validators.required : null);
  }

  filterClick(type) {
    switch (type) {
      case 'total_active': {
        this.filterByClick(1);
        break;
      }
      case 'total_complete': {
        this.filterByClick(3);
        break;
      }
      case 'total_doing': {
        this.filterByClick(6);
        break;
      }
      case 'total_reject': {
        this.filterByClick(4);
        break;
      }
      case 'total_change_info': {
        this.filterByClick(5);
        break;
      }
    }
  }

  getListProduct(name?) {
    let opt: any;
    if (name) {
      opt = {
        limit: this.limitProd,
        offset: this.offsetProd,
        name,
      };
    } else {
      opt = {
        limit: this.limitProd,
        offset: this.offsetProd,
      };
    }

    return this.productService
      .getProducts(opt)
      .toPromise()
      .then((res) => {
        if (!res.error) {
          const products = res.data.products;
          const arrTmp = [];
          for (let i = 0; i < products.length; i++) {
            const item = {
              value: products[i].id.toString(),
              label: products[i].name,
            };
            arrTmp.push(item);
          }
          this.listProducts = arrTmp;
        }
      });
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      const cities = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
        cities.push({ value: c.id.toString(), label: c.name });

        // if (c.city_name == this.store.customer?.city) {
        //     this.loadDistrictData(c.id);
        // }
      });
      this.cities = citiesList;
      this.list_city = cities;
    });
  }

  loadDistrictData(id: number) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        const districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
      });
  }

  convert_guarantee_days(guarantee_days: number) {
    let time_format: string;
    if (guarantee_days % 365 == 0) {
      time_format = guarantee_days / 365 + ' năm';
    } else if (guarantee_days % 31 == 0) {
      time_format = guarantee_days / 31 + ' tháng';
    } else {
      time_format = guarantee_days + ' ngày';
    }
    return time_format;
  }

  resetForm(frm: NgForm) {
    $('#drp-list-product .clear').click();
    $('#product_id').val('').trigger('change');
    this.productId = null;
    $('#drp-list-product .clear').click();
    $('#_province').val('').trigger('change');
    $('#_district').val('').trigger('change');
    $('#status').val('').trigger('change');
    $('#type').val('').trigger('change');
    $('#distributionAgent').val('').trigger('change');
    frm.reset();
    this.current_filter = {};
    this.loadData({}, this.isSorting);
    this.getStasitic();
  }

  getStasitic() {
    const request = {};
    this.stampService.guaranteeStasitic(request).subscribe((res) => {
      if (!res.error) {
        this.stasitic = res.data;
      }
    });
  }

  changeProduct(event) {
    this.productId = event ? event : null;
  }

  backToComponent() {
    this._location.back();
  }

  rowIndex(i: number) {
    if (this.currentPage == 1) {
      return i + 1;
    } else {
      return this.page_size * (this.currentPage - 1) + (i + 1); //currentPage start from: 0
    }
  }

  setPage(page: number) {
    if (page < 1) {
      this.currentPage = 1;
      return;
    }
    // this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.loadData(this.current_filter, this.isSorting);
    }
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    } else {
      this.setPage(1); //toPage = 1;
    }
  }

  setSort(sortBy) {
    this.isSorting = sortBy;
    this.loadData(null, this.isSorting);
  }

  backToList(event: any) {
    if (event.isBack == false) {
      this.item_active = 0;
      this.loadData(null, this.isSorting);
      this.getStasitic();
      this.isAdd = false;

      this.lgModal.hide();
      //this.modalRef.hide();
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  filterByClick(index) {
    this.model = {};
    this.current_filter = {};
    const modelQuery: any = {};
    $('#_province').val('').trigger('change');
    $('#_district').val('').trigger('change');
    modelQuery.status = index;
    const status_ele = $('#status');
    status_ele.val(modelQuery.status).trigger('change');
    if (index == 3 || index == 4 || index == 6) {
      modelQuery.status = 2;
      modelQuery.state = index;
      status_ele.val(modelQuery.state).trigger('change');
    }
    this.current_filter = modelQuery;
    this.currentPage = 1;
    this.loadData(modelQuery, this.isSorting);
    this.onSubmit();
  }

  updateStatus_1(status, i) {
    // let rq = this.logs_of_serial[i]
    // if(this.guarantee_note) {
    //   rq.note = this.guarantee_note
    // }
    // console.log(this.logs_of_serial[i]);
    this.stampService
      .updateGuaranteeStatusById(
        this.logs_of_serial[i].id,
        status,
        this.logs_of_serial[i]
      )
      .subscribe((res) => {
        if (!res.error) {
          this.toastr.info(
            this.translate.instant('DA_CHUYEN_TRANG_THAI_SANG') + ' ' + this.guarantee_title_dialog,
            '',
            {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            }
          );
          this.viewDetail(this.serial_info.serial, this.item_active);
        }
        this.logs_of_serial[i].displayDialog = false;
      });
  }

  showBasicDialog(status, log) {
    switch (status) {
      case 3: {
        this.guarantee_title_dialog = this.translate.instant('HOAN_THANH_BAO_HANH');
        this.status_guarantee = 3;
        break;
      }
      case 4: {
        this.guarantee_title_dialog = this.translate.instant('TU_CHOI_BAO_HANH');
        this.status_guarantee = 4;
        break;
      }
    }
    log.displayDialog = true;
  }

  loadData(request: any = {}, sort: any) {
    this.loading_data = true;
    this.waitPage = true;
    if (_.isEmpty(request)) {
      request = this.current_filter;
    }

    request.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    request.sort_by = 'created_time:' + sort;
    // this.stampService.guaranteeStasitic(request)
    //     .subscribe(res => {
    //         if (!res.error) {
    //             this.stasitic = res.data;
    //         }
    //     })
    this.stampService
      .getLogGuarantee(request)
      .toPromise()
      .then((res) => {
        this.loading_data = false;
        //console.log('log guarantee', res);
        if (res.status == 200 && res.error == false) {
          // this.totalRow = res.data.total;
          //
          // this.totalItem = res.data.total;
          // var pageString = (this.totalItem / this.page_size).toString();
          // var pageSplit = pageString.split('.');
          // var last: any;
          // var totalpage = parseInt(pageSplit[0]);
          // if (pageSplit.length > 1) {
          //   last = pageSplit[1];
          //   if (parseInt(last) > 0) {
          //     totalpage++
          //   }
          // }
          // this.totalPage = totalpage;

          if (res.data.serial && res.data.serial.length > 0) {
            this.logs = res.data.serial;
            for (let i = 0; i < this.logs.length; i++) {
              if (this.logs[i].product) {
                this.logs[i].product.image = this.imageService.readSrcImage(
                  this.logs[i].product.image,
                  'thumb_medium'
                );
              }
            }
            this.has_list = true;
            this.waitPage = false;
            for (const serial of res.data.serial) {
            }

            // for (let i = 0; i < this.logs.length; i++) {
            //   if (this.logs[i].customer) {
            //     let reg = new RegExp('^\\d+$');
            //     let isNumber = reg.test(this.logs[i].customer.name);
            //     if (isNumber) {
            //       this.logs[i].customer.isNumber = true;
            //     }
            //   }
            //   if (this.logs[i].prefix && this.logs[i].number) {
            //     let pad = '000000';
            //     let number = this.logs[i].number.toString();
            //     this.logs[i].serial = this.logs[i].prefix + '-' + pad.substring(0, 6 - number.length) + number;
            //   }
            // }
            this.viewDetail(
              this.logs[this.item_active].serial,
              this.item_active
            );
          } else {
            this.logs = [];
            this.serial_info = null;
            this.logs_of_serial = null;
          }
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.status + ' : ' + res.message,
          };
        }
        //this.setPage(this.currentPage);
      })
      .catch((err) => {
        EvsErr.evs_err(err);
      });
  }

  getFieldGuarantee() {
    this.stampService
      .getFieldGuarantee({ limit: 100 })
      .toPromise()
      .then((res) => {
        if (!res.error && res.data) {
          this.listFieldGuarantee = res.data.filter(
            (item: any) => item.status == 1
          );
        }
      });
  }

  viewDetail(serial, i) {
    if (!serial) {
      const log = this.logs[i];
      this.serial_info = {
        serial: '',
        product_name: log.product ? log.product.name : 'Chưa có sản phẩm',
        batch_name: '',
        active_time: '',
        active_time_f: '',
        expired_time: '',
        expired_time_f: '',
        is_expired: false,
      };

      const logObj = {
        id: log.id || log._id,
        code: log.code,
        serial: log.serial || '',
        product_code: log.product_code,
        created_time: log.created_time,
        created_time_f: moment(log.created_time).format('DD/MM/YYYY'),
        updated_time: log.updated_time,
        updated_time_f: moment(log.updated_time).format('DD/MM/YYYY'),
        purchase_time: log.purchase_time,
        purchase_time_f: log.purchase_time ? moment(log.purchase_time).format('DD/MM/YYYY') : '',
        customer: log.customer,
        user_created: log.user_created,
        note: log.note || log.delete_reason || '',
        status: log.status && log.status.id ? log.status.id : log.status,
        status_f: log.status && log.status.name ? log.status.name : '',
        state: log.state && log.state.id ? log.state.id : log.state,
        state_f: log.state && log.state.name ? log.state.name : '',
        is_active: false,
        is_receive: false,
        is_wait: true,
        is_reject: false,
        is_done: false,
        fields: log.fields,
        fields_customer: log.customer ? log.customer.fields : '',
        type: log.type,
        images: log.images,
        variant: log.extra,
        historyUpdated: [],
        isLoadHistoryUpdate: false,
        historyUpdatedCurrentPage: 1,
        historyUpdatedTotal: 0,
      };

      this.logs_of_serial = [logObj];
      this.item_active = i;
      this.getHistoryNoteInProgress2(logObj.id, 0);
      return;
    }

    this.stampService
      .getLogGuaranteeBySerial(serial, { offset: 0, limit: 100 })
      .subscribe((res) => {
        if (!res.error && res.data) {
          const serial_info = res.data.serial_info;
          this.agency_info = res.data.agency_info;
          this.warrantyReminderConfig = res.data.warrantyReminderConfig || null;
          this.update_permission = res.data.update_permission
          this.serial_info = {
            serial: serial,
            internal_serial: serial_info.internal_serial,
            internal_qrm: serial_info.internal_qrm,
            internal_qri: serial_info.internal_qri,
            internal_sms: serial_info.internal_sms,
            qrmMappingCode: serial_info.batch.qrmMappingCode,
            batch_name: serial_info.batch.name,
            produce_time: serial_info.batch.produce_time,
            produce_time_f: moment(serial_info.batch.produce_time).format(
              'DD/MM/YYYY'
            ),
            guarantee_days:
              serial_info.batch.guarantee_days > 0
                ? this.convert_guarantee_days(serial_info.batch.guarantee_days)
                : null,
            guarantee_days_max:
              serial_info.batch.guarantee_days_max > 0
                ? this.convert_guarantee_days(
                  serial_info.batch.guarantee_days_max
                )
                : null,
            guarantee_days_update: serial_info.batch.guarantee_days_update,
            guarantee_days_max_update:
              serial_info.batch.guarantee_days_max_update,
            type_guarantee_day: serial_info.batch.type_guarantee_day,
            type_guarantee_day_max: serial_info.batch.type_guarantee_day_max,

            product_name: serial_info.product.name,
            active_time: serial_info.time.active_time ? moment(serial_info.time.active_time).format(
              'DD/MM/YYYY HH:mm:ss'
            ) : '',
            active_time_f: serial_info.time.active_time ? moment(serial_info.time.active_time).format(
              'DD/MM/YYYY HH:mm:ss'
            ) : '',
            expired_time: serial_info.time.expired_time ? moment(serial_info.time.expired_time).format(
              'DD/MM/YYYY HH:mm:ss'
            ) : '',
            expired_time_f: serial_info.time.expired_time ? moment(serial_info.time.expired_time).format(
              'DD/MM/YYYY HH:mm:ss'
            ) : '',
            is_expired:
              moment(serial_info.time.expired_time).format('YYYYMMDD') <=
              moment(new Date()).format('YYYYMMDD'),

            third_party_product_id: serial_info.product.third_party_product_id,
            third_party_vendor_id: serial_info.product.third_party_vendor_id,
            vendor_name: serial_info.product.vendor_name,
            batch_vendor_code: serial_info.batch.batch_vendor_code,
            batch_order_code: serial_info.batch.batch_order_code,

          };

          const list_logs_of_serial = [];
          for (const log of res.data.logs) {
            const has_state = log.state && log.state.id && log.state.id > 0;
            if (log.fields) {
              for (let i = 0; i < log.fields.length; i++) {
                if (log.fields[i].value) {
                  const stringValue = log.fields[i].value.split('\n');
                  if (stringValue.length > 1) {
                    const listText: any = [];
                    for (let h = 0; h < stringValue.length; h++) {
                      listText.push(stringValue[h]);
                    }
                    log.fields[i]['haveEnter'] = true;
                    log.fields[i].value = listText;
                  }
                }
              }
            }
            if (log.customer && log.customer.fields) {
              for (let i = 0; i < log.customer.fields.length; i++) {
                if (log.customer.fields[i].value) {
                  console.log('log.customer.fields[i]', log.customer.fields[i])
                  let stringValue = ''
                  if (log.customer.fields[i].type === 'image') {
                    stringValue = log.customer.fields[i].value;
                  } else {
                    stringValue = log.customer.fields[i].value
                  }
                  if (stringValue.length > 1) {
                    const listText: any = [];
                    for (let h = 0; h < stringValue.length; h++) {
                      listText.push(stringValue[h]);
                    }
                    log.customer.fields[i]['haveEnter'] = true;
                    log.customer.fields[i].value = listText;
                  }
                }
              }
            }
            let obj: any;
            obj = {
              id: log._id,
              code: log.code,
              serial: log.serial || '',
              product_code: log.product_code,
              created_time: log.created_time,
              created_time_f: moment(log.created_time).format('DD/MM/YYYY'),
              updated_time: log.updated_time,
              updated_time_f: moment(log.updated_time).format('DD/MM/YYYY'),
              purchase_time: log.purchase_time,
              purchase_time_f: log.purchase_time ? moment(log.purchase_time).format('DD/MM/YYYY') : '',
              customer: log.customer,
              user_created: log.user_created,
              note: log.note || log.delete_reason || '',
              status: log.status.id,
              status_f: log.status.name,
              state: has_state ? log.state.id : null,
              state_f: has_state ? log.state.name : null,
              is_active: log.status.id == 1,
              is_receive: log.status.id == 5,
              is_wait: log.status.id == 2 && log.state.id == 6,
              is_reject: log.status.id == 2 && log.state.id == 4,
              is_done: log.status.id == 2 && log.state.id == 3,
              // fields: log.status.id !== 2 ? log.customer.fields : log.fields,
              fields: log.fields,
              fields_customer: log.customer ? log.customer.fields : '',
              type: log.type,
              images: log.images,
              variant: log.extra,
              historyUpdated: [],
              isLoadHistoryUpdate: false,
              historyUpdatedCurrentPage: 1,
              historyUpdatedTotal: 0,
            };
            list_logs_of_serial.push(obj);
          }
          for (let i = 0; i < list_logs_of_serial.length; i++) {
            this.getHistoryNoteInProgress2(list_logs_of_serial[i].id, i);
          }
          this.logs_of_serial = list_logs_of_serial;
          this.qri_serial_detail = res.data.serial_info.qri
          console.log('qqq', this.logs_of_serial);
          console.log('qri_serial_detail', this.qri_serial_detail);

        } else {
          this.serial_info = {};
          this.logs_of_serial = [];
        }
      });
    this.item_active = i;
  }

  onSubmit() {
    let index;
    this.item_active = 0;
    const modelQuery = <any>{};

    if (this.model.serial) {
      modelQuery.serial = this.model.serial;
    }
    if (this.model.sms) {
      modelQuery.code = this.model.sms;
    }
    if (this.model.product) {
      modelQuery.product = this.model.product;
    }
    const type = $('#type option:selected').text().trim();
    if (type != '') {
      index = this.types.indexOf(type);
      if (index >= 0) {
        modelQuery.type = this.typeValues[index];
      }
    }
    // if (this.model.name) {
    //     modelQuery.name = this.model.name;
    // }
    if (this.model.phone) {
      modelQuery.phone = this.model.phone;
    }
    // if (this.model.email) {
    //     modelQuery.email = this.model.email;
    // }
    // let product_id = $("#product_id").val();
    if (this.productId) {
      modelQuery.product_id = this.productId;
    }
    const status = $('#status option:selected').text().trim();
    if (status != '') {
      index = this.type_list.indexOf(status) + 1;
      if (index > 0) {
        modelQuery.status = index;
        if (index == 3 || index == 4 || index == 6) {
          modelQuery.status = 2;
          modelQuery.state = index;
        }
      }
    }

    const created_time_val = $('#created_time').val();
    if (created_time_val) {
      const listDate = created_time_val.toString().split(' - ');
      if (listDate.length > 1) {
        modelQuery.from = moment(listDate[0], ['DD/MM/YYYY'])['_d'];
        modelQuery.to = moment(listDate[1], ['DD/MM/YYYY'])['_d'];
      }
    }

    const agency_id = $('#distributionAgent').val();
    if (agency_id) {
      modelQuery.agency_id = agency_id;
    }
    this.currentPage = 1;
    this.current_filter = modelQuery;

    // return;
    this.loadData(modelQuery, this.isSorting);
  }

  // guarantee add note inprogress - show dialog update
  showNoteInProgressDialog() {
    this.isShowNoteInProgressDialog = true;
  }

  // guarantee add note inprogress - upload images
  tusUpload = (item: any) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      // for (const image of item.target.files) {
      //   const reader = new FileReader();
      //   reader.onload = (e) => {
      //     const fileData = new FormData();
      //     fileData.append('file', image);
      //     return this.upload.uploadImagesNew2(fileData).subscribe((res: any) => {
      //       const response = JSON.parse(res._body)
      //       console.log('response', response)
      //       console.log('res', res)
      //       console.log('res body', res._body)
      //       const result = {
      //         id: response.data.fileId,
      //         url: response.data.url,
      //       };
      //       console.log('image', result)
      //       if (this.imagesNoteInProgress.length >= 5) {
      //         this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
      //           timeOut: 4000,
      //           positionClass: 'toast-bottom-right',
      //         });
      //       } else {
      //         this.imagesNoteInProgress.push(result);
      //       }
      //       console.log('imagesNoteInProgress', this.imagesNoteInProgress)
      //     });
      //   };
      //   console.log('imagesNoteInProgress222', this.imagesNoteInProgress)
      //   // reader.readAsArrayBuffer(image);
      // }
      for (const image of item.target.files) {
        const fileData = new FormData();
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = {
              id: res.data.fileId,
              url: res.data.url,
            };
            if (this.imagesNoteInProgress.length >= 5) {
              this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.imagesNoteInProgress.push(image2);
            }
          }
        });
      }
      console.log('imagesNoteInProgress 3333', this.imagesNoteInProgress)
    }
    console.log('imagesNoteInProgress imagesNoteInProgress', this.imagesNoteInProgress)
  };

  tusUpload2 = async (item) => {
    const numberImages = item.target.files.length;
    console.log('numberImages', numberImages);
    console.log('this.img', this.imagesNoteInProgress.length);

    if (numberImages + this.imagesNoteInProgress.length > 5) {
      this.toastr.error('Tổng số ảnh không được vượt quá 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      const uploadPromises = [];
      for (const image of item.target.files) {
        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        // Chuyển Observable thành Promise để sử dụng await
        uploadPromises.push(
          new Promise((resolve, reject) => {
            this.upload.uploadImagesNew2(fileData).subscribe({
              next: (response: any) => {
                const res = JSON.parse(response._body);
                if (res.status === 200) {
                  const image2 = {
                    id: res.data.fileId,
                    url: res.data.url,
                  };
                  if (this.imagesNoteInProgress.length >= 5) {
                    this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                      timeOut: 4000,
                      positionClass: 'toast-bottom-right',
                    });
                  } else {
                    this.imagesNoteInProgress.push(image2);
                    console.log('i23123', this.imagesNoteInProgress);
                  }
                }
                resolve(res);
              },
              error: (err) => reject(err)
            });
          })
        );
      }
      // Chờ tất cả upload hoàn tất
      await Promise.all(uploadPromises);
      console.log('imagesNoteInProgress imagesNoteInProgress', this.imagesNoteInProgress);
    }
    console.log('Result', this.imagesNoteInProgress);
  };

  // xóa ảnh
  deleteImageNoteInProgress(id: number) {
    for (let i = 0; i < this.imagesNoteInProgress.length; i++) {
      if (this.imagesNoteInProgress[i].id === id) {
        this.imagesNoteInProgress.splice(
          this.imagesNoteInProgress.indexOf(this.imagesNoteInProgress[i]),
          1
        );
        break;
      }
    }
  }

  downloadExcel() {
    const arrField = $('#listFieldGuarantee').val();
    const fields = arrField ? arrField.join(',') : null;

    const modelQuery = <any>{};

    if (this.model.serial) {
      modelQuery.serial = this.model.serial;
    }
    if (this.model.sms) {
      modelQuery.code = this.model.sms;
    }
    if (this.model.product) {
      modelQuery.product = this.model.product;
    }
    const type = $('#type option:selected').text().trim();
    if (type != '') {
      const index = this.types.indexOf(type);
      if (index >= 0) {
        modelQuery.type = this.typeValues[index];
      }
    }
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    if (this.model.phone) {
      modelQuery.phone = this.model.phone;
    }
    const product_id = $('#product_id').val();
    if (product_id) {
      modelQuery.product_id = product_id;
    }
    // if (this.model.email) {
    //     modelQuery.email = this.model.email;
    // }
    const status_option_selected = $('#status>option:selected');
    let status = status_option_selected.text().trim();
    if (status != '') {
      const index = this.type_list.indexOf(status) + 1;
      if (index > 0) {
        modelQuery.status = index;
        if (index == 3 || index == 4 || index == 6) {
          modelQuery.status = 2;
          modelQuery.state = index;
        }
      }
    }
    const created_time_val = $('#created_time').val();
    if (created_time_val) {
      const listDate = created_time_val.toString().split(' - ');
      if (listDate.length > 1) {
        // modelQuery.from = new Date(listDate[0]);
        // modelQuery.to = new Date(listDate[1]);
        const a = listDate[0].split('/');
        const resultFrom = a[2] + '-' + a[1] + '-' + a[0];
        modelQuery.from = resultFrom;
        const b = listDate[0].split('/');
        const resultTo = b[2] + '-' + b[1] + '-' + b[0];
        modelQuery.to = resultTo;
      }
    }
    let url = environment.api_evs + '/guarantee/excel?';
    if (modelQuery.serial) {
      url += 'serial=' + modelQuery.serial;
    }
    if (modelQuery.code) {
      url += '&code=' + modelQuery.code;
    }
    if (modelQuery.product) {
      url += '&product=' + modelQuery.product;
    }
    if (modelQuery.type) {
      url += '&type=' + modelQuery.type;
    }
    if (modelQuery.name) {
      url += '&name=' + modelQuery.name;
    }
    if (modelQuery.phone) {
      url += 'phone=' + modelQuery.phone;
    }
    if (modelQuery.product_id) {
      url += '&product_id=' + modelQuery.product_id;
    }
    if (modelQuery.email) {
      url += '&email=' + modelQuery.email;
    }
    if (modelQuery.from) {
      url += '&from=' + modelQuery.from;
    }
    if (modelQuery.to) {
      url += '&to=' + modelQuery.to;
    }
    status = status_option_selected.text().trim();
    if (status != '') {
      const index = this.type_list.indexOf(status) + 1;
      if (index > 0) {
        url += '&status=' + index;
      }
    }

    url += '&sort_by=created_time:' + this.isSorting;
    if (fields) {
      url += '&fields=' + fields;
    }
    if (localStorage.getItem('Access-Token')) {
      url += '&Access_Token=' + localStorage.getItem('Access-Token');
    }
    location.href = url;
    this.bsModalDownload.hide();
  }

  // xử lý popup download excel
  showPopupDownload(template) {
    this.bsModalDownload = this.modalService.show(template);
    $('#listFieldGuarantee').select2({
      placeholder: 'Chọn danh mục cần tải',
      dropdownCssClass: 'increasedzindexclass',
      allowClear: true,
      width: '100%',
      multiple: true,

    });
    this.getFieldGuarantee();
  }

  // xem thêm lịch sử cập nhật bảo hành
  showMoreHistoryNoteInProgress(logId: string, index: number) {
    this.logs_of_serial[index].historyUpdatedCurrentPage += 1;
    this.logs_of_serial[index].isLoadHistoryUpdate = false;
    this.currentLogId = '-1';
    this.getHistoryNoteInProgress(logId, index);
  }

  convertDate(time?) {
    return time.split('T')[0]
  }

  closeNoteInProgress() {
    this.isShowNoteInProgressDialog = !this.isShowNoteInProgressDialog;
    this.noteInProgress.note = '';
    this.imagesNoteInProgress = [];
  }

  openActiveTemp(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
    this.choiceActive();
  }

  findCustomerByPhone() {
    console.log(111);
    if (this.infoActive.phone) {
      if (this.infoActive.phone.length > 0) {
        this.stampService
          .getUserByPhone(this.infoActive.phone)
          .subscribe((res) => {
            if (!res.error) {
              if (res.data.customer) {
                // tslint:disable-next-line:prefer-const
                let info = res.data.customer;
                this.toastr.info(
                  `Đã tải về thông tin khách hàng có số điện thoại` +
                  this.infoActive.phone,
                  '',
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  });
                this.infoActive.name = info.name;
                this.infoActive.email = info.email;
                this.infoActive.address = info.address;
                this.infoActive.fields = info.fields;


                this.cusomerUpdate = {}
                this.listRequire = []
                this.cusomerUpdate['nameField'] = {}
                this.cusomerUpdate['fields'] = {}
                this.stampService.getFieldGuaranteeCustomes().subscribe((res) => {
                  if (res.data.length > 0) {
                    this.listField = res.data;
                    this.listField.map((val) => {
                      this.typeField[val.key] = val.type
                      this.typeName[val.key] = val.name
                      if (val.require === 1 && val.status === 1) {
                        this.listRequire.push(val.key)
                      }
                      this.cusomerUpdate['nameField'][val.key] = val.name
                      if (val.type === 'checkbox') {
                        this.cusomerUpdate['fields'][val.key] = {}
                        val.value_f.map((n) => {
                          this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
                        })
                      }
                      if (this.infoActive.fields && this.infoActive.fields.length > 0) {
                        this.infoActive.fields.map((item) => {
                          if (item.key === val.key) {

                            if (val.type === 'date') {

                              this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                            } else if (val.type === 'checkbox') {
                              this.cusomerUpdate['fields'][val.key] = {}
                              val.value_f.map((n) => {
                                if (item.string_values.split(',').includes(String(n.id))) {
                                  this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                                }
                              })

                            } else if (val.type === 'image') {
                              this.imagesFields[val.key] = item.string_values === null ? [] : item.string_values
                            } else {
                              this.cusomerUpdate['fields'][val.key] = item.string_values

                            }
                          }

                        })
                      }
                    })
                  }

                });


                if (info.city && info.district) {
                  this.infoActive.city = info.city.toString();
                  this.getListDistrict(
                    this.infoActive.city,
                    info.district,
                    1
                  );
                }

              }
            }
          });
      }
    }

  }

  // thêm mới 1 log cập nhật bảo hành
  submitNewUpdatedNoteGuarantee(logId: string, index: number) {
    if (this.noteInProgress.note.trim() == '') {
      this.toastr.error('Note không để trống', '', {
        timeOut: 2000,
        positionClass: 'toast-bottom-right',
      });
      this.noteInProgress.note = '';
      return;
    }
    const submitData = {
      note: this.noteInProgress.note.trim() || null,
      images: this.imagesNoteInProgress.map((item: any) => item.url),
    };
    this.stampService
      .createNewUpdatedNoteGuarantee(logId, submitData)
      .subscribe((res: any) => {
        if (!res.error) {
          this.toastr.success('Thêm mới cập nhật bảo hành thành công', '', {
            timeOut: 2000,
            positionClass: 'toast-bottom-right',
          });
          this.logs_of_serial[index].historyUpdated = [];
          this.isShowNoteInProgressDialog = false;
          this.currentLogId = '-1';
          this.logs_of_serial[index].historyUpdatedCurrentPage = 1;
          this.logs_of_serial[index].isLoadHistoryUpdate = false;
          this.noteInProgress.note = '';
          this.imagesNoteInProgress = [];
          this.getHistoryNoteInProgress(logId, index);
        } else {
          this.toastr.error('Thêm cập nhật bảo hành thất bại', '', {
            timeOut: 2000,
            positionClass: 'toast-bottom-right',
          });
        }
      });
  }

  // changeCountry(e) {
  //   // if (this.selectedCountry !== "241") {
  //   //   this.cities = [];
  //   //   this.districts = [];
  //   // } else {
  //   if (e === 'infoChange') {
  //     this.getListCity(this.infoChange.country);
  //     this.infoChange.city = '';
  //     this.infoChange.district = '';
  //
  //   } else if (e === 'infoActive') {
  //     this.getListCity(this.infoActive.country);
  //     this.infoActive.city = '';
  //     this.infoActive.district = '';
  //
  //   } else {
  //     this.getListCity(this.selectedCountry);
  //     this.selectedCityId = '';
  //     this.selectedDistrictId = '';
  //   }
  //   this.list_city = []
  //   this.list_districtActive = []
  //
  //
  //   // }
  // }

  openActiveBoxStamp(template: TemplateRef<any>) {
    this.checkboxSingle = false
    this.modalRef = this.modalService.show(template)
    this.errMsg = '';
    this.choiceActiveBoxStamp();
  }

  // getListCity(id: string) {
  //   this.addressService
  //     .getCities()
  //     .toPromise()
  //     .then((res: any) => {
  //       if (res.status == 200) {
  //         let cities = [];
  //         for (let c of res.data.cities) {
  //           cities.push({value: c.id.toString(), label: c.name});
  //         }
  //         this.list_city = cities;
  //         // console.log(this.list_city);
  //       }
  //     });
  // }

  findCustomerByPhoneBoxStamp() {
    console.log(111);
    if (this.infoActiveBoxStamp.phone) {
      if (this.infoActiveBoxStamp.phone.length > 0) {
        this.stampService
          .getUserByPhone(this.infoActiveBoxStamp.phone)
          .subscribe((res) => {
            if (!res.error) {
              if (res.data.customer) {
                // tslint:disable-next-line:prefer-const
                let info = res.data.customer;
                this.toastr.info(
                  `Đã tải về thông tin khách hàng có số điện thoại` +
                  this.infoActiveBoxStamp.phone,
                  '',
                  {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  });
                this.infoActiveBoxStamp.name = info.name;
                this.infoActiveBoxStamp.email = info.email;
                this.infoActiveBoxStamp.address = info.address;
                this.infoActiveBoxStamp.fields = info.fields;


                this.cusomerUpdateBoxStamp = {}
                this.listRequireBoxStamp = []
                this.cusomerUpdateBoxStamp['nameField'] = {}
                this.cusomerUpdateBoxStamp['fields'] = {}
                this.stampService.getFieldGuaranteeCustomes().subscribe((res) => {
                  if (res.data.length > 0) {
                    this.listFieldBoxStamp = res.data;
                    this.listFieldBoxStamp.map((val) => {
                      this.typeField[val.key] = val.type
                      this.typeName[val.key] = val.name
                      if (val.require === 1 && val.status === 1) {
                        this.listRequireBoxStamp.push(val.key)
                      }
                      this.cusomerUpdateBoxStamp['nameField'][val.key] = val.name
                      if (val.type === 'checkbox') {
                        this.cusomerUpdateBoxStamp['fields'][val.key] = {}
                        val.value_f.map((n) => {
                          this.cusomerUpdateBoxStamp['fields'][val.key][`check${n.id}`] = false
                        })
                      }
                      if (this.infoActiveBoxStamp.fields && this.infoActiveBoxStamp.fields.length > 0) {
                        this.infoActiveBoxStamp.fields.map((item) => {
                          if (item.key === val.key) {

                            if (val.type === 'date') {

                              this.cusomerUpdateBoxStamp['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                            } else if (val.type === 'checkbox') {
                              this.cusomerUpdateBoxStamp['fields'][val.key] = {}
                              val.value_f.map((n) => {
                                if (item.string_values.split(',').includes(String(n.id))) {
                                  this.cusomerUpdateBoxStamp['fields'][val.key][`check${n.id}`] = String(n.id)
                                }
                              })

                            } else if (val.type === 'image') {
                              this.imagesFieldsBoxStamp[val.key] = item.string_values === null ? [] : item.string_values
                            } else {
                              this.cusomerUpdateBoxStamp['fields'][val.key] = item.string_values

                            }
                          }

                        })
                      }
                    })
                  }

                });


                if (info.city && info.district) {
                  this.infoActiveBoxStamp.city = info.city.toString();
                  this.getListDistrict(
                    this.infoActiveBoxStamp.city,
                    info.district,
                    1
                  );
                }

              }
            }
          });
      }
    }

  }

  // lấy danh sách lịch sử cập nhật bảo hành
  getHistoryNoteInProgress(logId: string, index: number) {
    // if (this.currentLogId == logId) {
    //   return;
    // } else {
    this.currentLogId = logId;
    // }

    if (this.logs_of_serial[index].isLoadHistoryUpdate) {
      return;
    }

    const opt = {
      limit: this.NoteInProgressPageSize,
      offset:
        this.NoteInProgressPageSize *
        (this.logs_of_serial[index].historyUpdatedCurrentPage <= 0
          ? 0
          : this.logs_of_serial[index].historyUpdatedCurrentPage - 1),
    };

    this.stampService
      .getListHistoryNoteInProgress(logId, opt)
      .subscribe((res: any) => {
        if (!res.error && res.data) {
          this.logs_of_serial[index].historyUpdatedTotal = res.data.logs.total;
          const tmpArr = res.data.logs.list.map((item: any) => {
            return {
              id: item._id,
              note: item.note,
              images: item.images,
              createdAt: item.created_at,
            };
          });
          this.logs_of_serial[index].historyUpdated = [
            ...this.logs_of_serial[index].historyUpdated,
            ...tmpArr,
          ];
          this.logs_of_serial[index].isLoadHistoryUpdate = true;
        }
      });
  }

  getHistoryNoteInProgress2(logId: string, index: number) {
    this.currentLogId = logId;
    const opt = {
      limit: this.NoteInProgressPageSize,
      offset: 0
    };

    this.stampService
      .getListHistoryNoteInProgress(logId, opt)
      .subscribe((res: any) => {
        if (!res.error && res.data) {
          this.logs_of_serial[index].historyUpdatedTotal = res.data.logs.total;
          const tmpArr = res.data.logs.list.map((item: any) => {
            return {
              id: item._id,
              note: item.note,
              images: item.images,
              createdAt: item.created_at,
            };
          });
          this.logs_of_serial[index].historyUpdated2 = [...tmpArr];
        }
      });
  }

  getListDistrict(city_Id: any, districtID: any, status) {
    if (city_Id) {
      this.addressService
        .getDistrict({ city_id: city_Id })
        .toPromise()
        .then((res: any) => {
          if (res.status == 200) {
            const districts = [];
            for (const d of res.data.districts) {
              districts.push({ value: d.id.toString(), label: d.name });
            }
            this.list_districtActive = districts;
            console.log('list_districtActive', this.list_districtActive)
            console.log('districtID', districtID)

            this.infoActive.district = districtID ? districtID.toString() : null;

          }
        });
    }
  }

  excecute() {

    this.errMsgAlertSingleStamp = '';
    const request: any = {
      customer: {},
    };
    request.status = 1;
    request.bundleType = 0;
    if (!this.infoActive.phone || this.infoActive.phone == '') {
      this.toastr.warning(`Số điện thoại không được để trống`, '', {
        timeOut: 400000000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      request.customer.phone = this.infoActive.phone;
      $('#phoneValidate').text('');
    }

    if (!this.infoActive.name || this.infoActive.name == '') {
      this.toastr.warning(`Tên khách hàng không được để trống`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      request.customer.name = this.infoActive.name;
      $('#nameValidate').text('');
    }
    this.infoActive.serial_ids = $('#serial_ids_stamps').val();
    if (!this.infoActive.serial_ids || this.infoActive.serial_ids == '') {
      this.toastr.warning(`Serial không được để trống`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      const listContent = [];
      const content = this.infoActive.serial_ids.toUpperCase().split('\n');
      content.map((res) => {
        if (res.trim().length > 0) {
          if (!isNaN(res.trim().split('-')[res.trim().split('-').length - 1])) {
            listContent.push({
              prefix: res.trim().split('-')[0],
              serialStart: res.trim().split('-')[res.trim().split('-').length - 1],
              serialEnd: res.trim().split('-')[res.trim().split('-').length - 1]
            });
          } else {
            this.toastr.warning(
              `Định dạng serial không đúng`,
              `Kích hoạt thất bại`,
              {
                timeOut: 3000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            return
          }

        }
      });
      request.stamps = listContent;
      $('#serialValidateInfoActive').text('');
    }
    if (this.infoActive.email && this.infoActive.email != '') {
      request.customer.email = this.infoActive.email;
    } else {
      request.customer.email = ''
    }
    if (this.infoActive.address && this.infoActive.address != '') {
      request.customer.address = this.infoActive.address;
    } else {
      request.customer.address = ''
    }
    // if (this.infoActive.country && this.infoActive.country != '') {
    //   request.customer.country = parseInt(this.infoActive.country);
    // }
    if (this.infoActive.city && this.infoActive.city != '') {
      request.customer.city = parseInt(this.infoActive.city);
    }
    if (this.infoActive.district && this.infoActive.district != '') {
      request.customer.district = parseInt(this.infoActive.district);
    }

    // if (this.variantId) {
    //   request.variant_id = this.variantId;
    // }

    if (this.infoActive.product_code) {
      request.product_code = this.infoActive.product_code;
    }
    console.log('request', request);

    for (const val in this.imagesFields) {
      console.log(`${val}: ${this.imagesFields[val]}`);
      this.cusomerUpdate['fields'][val] = this.imagesFields[val];
    }

    const fieldsData = {}
    for (const property in this.cusomerUpdate['fields']) {
      if (this.typeField[property] === 'select' && this.listRequire.includes(property) && this.cusomerUpdate['fields'][property] === '-1') {
        this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
      if (this.typeField[property] === 'image') {
        fieldsData[property] = this.cusomerUpdate['fields'][property]
        if (this.listRequire.includes(property) && fieldsData[property].length === 0) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

      if (this.typeField[property] === 'checkbox') {
        const arr = []
        for (const val in this.cusomerUpdate['fields'][property]) {
          if (typeof this.cusomerUpdate['fields'][property][val] === 'boolean') {
            if (this.cusomerUpdate['fields'][property][val]) {
              const split = val.split('check')[1]
              arr.push(split)
            }
          } else {
            arr.push(this.cusomerUpdate['fields'][property][val])
          }

        }
        fieldsData[property] = arr.join(',')

        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else if (this.typeField[property] === 'date') {
        console.log('this.cusomerUpdate.fields[property]', this.cusomerUpdate['fields'][property])
        if (this.cusomerUpdate['fields'][property]) {
          let dataDate = this.cusomerUpdate['fields'][property]
          if (typeof this.cusomerUpdate['fields'][property] === 'object') {
            dataDate = moment(this.cusomerUpdate['fields'][property]).format('DD/MM/YYYY')
          }
          const date = dataDate.split('/')
          const dateTime = new Date(`${date[1]} ${date[0]} ${date[2]}`)
          fieldsData[property] = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toISOString();
        }
        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else {

        fieldsData[property] = this.cusomerUpdate['fields'][property]

        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

    }
    request.customer.fields = fieldsData
    if (
      request.customer.phone &&
      request.customer.phone !== '' &&
      request.customer.name &&
      request.customer.name !== ''
    ) {
      this.stampService
        .activeGuaranteeStamps(request)
        .toPromise()
        .then((res: any) => {
          if (res.code === 1) {

            this.toastr.success(
              `<div>Thành công: <b>${res.data.totalSuccess}</b>, Thất bại: <b>${res.data.totalFailure}</b></div>`,
              `Kích hoạt thành công`,
              {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            this.loadData({}, this.isSorting);
            this.modalRef.hide();
            this.infoActive = {};
          } else if (res.code === 1800) {

            this.errMsgAlertSingleStamp = res.message;
            $('.stampSingleAlert').css('opacity', '1');
            this.loadData({}, this.isSorting);
            this.modalRef.hide();
            this.infoActive = {};
            setTimeout(() => {
              $('.stampSingleAlert').css('opacity', '0');
            }, 5000)
            // this.toastr.error(
            //   res.message,
            //   `Thông báo`,
            //   {
            //     timeOut: 7000,
            //     positionClass: 'toast-bottom-right',
            //     enableHtml: true,
            //   }
            // );
          } else {
            this.toastr.error(
              res.message || `Kích hoạt thất bại`,
              `Thất bại`,
              {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            EvsErr.evs_err(res, false);
          }
        })
        .catch((err: any) => {
          this.errMsgAlertSingleStamp = err.message;
          $('.stampSingleAlert').css('opacity', '1');
          setTimeout(() => {
            $('.stampSingleAlert').css('opacity', '0');
          }, 5000)
          // this.toastr.error(err.message, '', {
          //   timeOut: 5000,
          //   positionClass: 'toast-bottom-right',
          // });
        });
    }
  }

  excecuteBoxStamp() {
    this.errMsg = '';
    const request: any = {
      customer: {},
    };
    request.status = 1;
    request.bundleType = 1;
    if (!this.infoActiveBoxStamp.phone || this.infoActiveBoxStamp.phone == '') {
      this.toastr.warning(`Số điện thoại không được để trống`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      request.customer.phone = this.infoActiveBoxStamp.phone;
      $('#phoneValidate').text('');
    }

    if (!this.infoActiveBoxStamp.name || this.infoActiveBoxStamp.name == '') {
      this.toastr.warning(`Tên khách hàng không được để trống`, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      return;
    } else {
      request.customer.name = this.infoActiveBoxStamp.name;
      $('#nameValidate').text('');
    }
    this.infoActiveBoxStamp.serial_ids = $('#serial_ids_box').val()
    if (!this.infoActiveBoxStamp.serial_ids || this.infoActiveBoxStamp.serial_ids == '') {
      this.errMsg = 'Mã tem thùng không được dể trống';
      return;
    } else {
      const listContent = [];
      const listContentError = [];
      const content = this.infoActiveBoxStamp.serial_ids.toUpperCase().split('\n');
      content.map((res) => {
        if (res.trim().length > 0) {
          if (!isNaN(res.trim().split('-')[res.trim().split('-').length - 1])) {
            listContent.push({
              prefix: res.trim().split('-')[0],
              serialStart: res.trim().split('-')[res.trim().split('-').length - 1],
              serialEnd: res.trim().split('-')[res.trim().split('-').length - 1]
            });

          } else {
            listContentError.push({
              prefix: res.trim().split('-')[0],
              serialStart: res.trim().split('-')[res.trim().split('-').length - 1],
              serialEnd: res.trim().split('-')[res.trim().split('-').length - 1]
            });
            return;
          }

        }
      });
      // Validate tem thùng
      if (listContent.length > 5) {
        this.errMsg = 'Danh sách tem thùng không được vượt quá 5 mã tem thùng';
        return;
      } else {
        this.errMsg = '';
      }
      if (listContentError.length > 5) {
        this.errMsg = 'Mã tem không phải mã tem thùng';
        return;
      } else {
        this.errMsg = '';
      }

      request.stamps = listContent;
      $('#serialValidate').text('');
    }
    if (this.infoActiveBoxStamp.email && this.infoActiveBoxStamp.email != '') {
      request.customer.email = this.infoActiveBoxStamp.email;
    } else {
      request.customer.email = ''
    }
    if (this.infoActiveBoxStamp.address && this.infoActiveBoxStamp.address != '') {
      request.customer.address = this.infoActiveBoxStamp.address;
    } else {
      request.customer.address = ''
    }

    if (this.infoActiveBoxStamp.city && this.infoActiveBoxStamp.city != '') {
      request.customer.city = parseInt(this.infoActiveBoxStamp.city);
    }
    if (this.infoActiveBoxStamp.district && this.infoActiveBoxStamp.district != '') {
      request.customer.district = parseInt(this.infoActiveBoxStamp.district);
    }

    if (this.infoActiveBoxStamp.product_code) {
      request.product_code = this.infoActiveBoxStamp.product_code;
    }
    console.log('request', request);
    // tslint:disable-next-line:forin
    for (const val in this.imagesFieldsBoxStamp) {
      console.log(`${val}: ${this.imagesFieldsBoxStamp[val]}`);
      this.cusomerUpdateBoxStamp['fields'][val] = this.imagesFieldsBoxStamp[val];
    }
    const fieldsData = {}
    for (const property in this.cusomerUpdateBoxStamp['fields']) {
      if (this.typeField[property] === 'select' && this.listRequireBoxStamp.includes(property) && this.cusomerUpdateBoxStamp['fields'][property] === '-1') {
        this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
      if (this.typeField[property] === 'image') {
        fieldsData[property] = this.cusomerUpdateBoxStamp['fields'][property]
        if (this.listRequire.includes(property) && fieldsData[property].length === 0) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

      if (this.typeField[property] === 'checkbox') {
        const arr = []
        for (const val in this.cusomerUpdateBoxStamp['fields'][property]) {
          if (typeof this.cusomerUpdateBoxStamp['fields'][property][val] === 'boolean') {
            if (this.cusomerUpdateBoxStamp['fields'][property][val]) {
              const split = val.split('check')[1]
              arr.push(split)
            }
          } else {
            arr.push(this.cusomerUpdateBoxStamp['fields'][property][val])
          }

        }
        fieldsData[property] = arr.join(',')

        if (this.listRequireBoxStamp.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else if (this.typeField[property] === 'date') {
        console.log('this.cusomerUpdateBoxStamp.fields[property]', this.cusomerUpdateBoxStamp['fields'][property])
        if (this.cusomerUpdateBoxStamp['fields'][property]) {
          let dataDate = this.cusomerUpdateBoxStamp['fields'][property]
          if (typeof this.cusomerUpdateBoxStamp['fields'][property] === 'object') {
            dataDate = moment(this.cusomerUpdateBoxStamp['fields'][property]).format('DD/MM/YYYY')
          }
          const date = dataDate.split('/')
          const dateTime = new Date(`${date[1]} ${date[0]} ${date[2]}`)
          fieldsData[property] = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toISOString();
        }
        if (this.listRequireBoxStamp.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else {

        fieldsData[property] = this.cusomerUpdateBoxStamp['fields'][property]

        if (this.listRequireBoxStamp.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

    }
    request.customer.fields = fieldsData


    if (
      request.customer.phone &&
      request.customer.phone !== '' &&
      request.customer.name &&
      request.customer.name !== '' &&
      this.errMsg === ''
    ) {
      this.stampService
        .activeGuaranteeStamps(request)
        .toPromise()
        .then((res: any) => {
          if (res.code === 1) {

            this.toastr.success(
              `<div>Thành công: <b>${res.data.totalSuccess}</b>, Thất bại: <b>${res.data.totalFailure}</b></div>`,
              `Kích hoạt thành công`,
              {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            this.loadData({}, this.isSorting);
            this.modalRef.hide();
            this.infoActiveBoxStamp = {};
            this.errMsg = '';
          } else if (res.code === 1800) {
            this.errMsgAlertBoxStamp = res.message;
            $('.stampBoxStampAlert').css('opacity', '1');
            this.loadData({}, this.isSorting);
            this.modalRef.hide();
            this.infoActiveBoxStamp = {};
            this.errMsg = '';
            setTimeout(() => {
              $('.stampBoxStampAlert').css('opacity', '0');
            }, 5000)
            // this.toastr.warning(
            //   res.message,
            //   `Thông báo`,
            //   {
            //     timeOut: 7000,
            //     positionClass: 'toast-bottom-right',
            //     enableHtml: true,
            //   }
            // );
          } else {
            this.toastr.error(
              res.message || `Kích hoạt thất bại`,
              `Thất bại`,
              {
                timeOut: 5000,
                positionClass: 'toast-bottom-right',
                enableHtml: true,
              }
            );
            EvsErr.evs_err(res, false);
          }
        })
        .catch((err: any) => {
          $('.stampBoxStampAlert').click(function () {
            console.log(7877777);
            this.style.opacity = 0;
          });
          this.errMsgAlertBoxStamp = err.message;
          $('.stampBoxStampAlert').css('opacity', '1');
          this.loadData({}, this.isSorting);
          this.modalRef.hide();
          this.infoActiveBoxStamp = {};
          this.errMsg = '';
          setTimeout(() => {
            $('.stampBoxStampAlert').css('opacity', '0');
          }, 5000)
          // this.toastr.warning(err.message, '', {
          //   timeOut: 5000,
          //   positionClass: 'toast-bottom-right',
          // });
        });
    }
  }

  // getCountries() {
  //   this.addressService.getCountries().subscribe((res) => {
  //     const list: Array<any> = [];
  //     for (const _data of res.data.countries) {
  //       const obj = {
  //         value: _data.id.toString(),
  //         label: _data.name,
  //         image: _data.ensign,
  //       };
  //       list.push(obj);
  //       if (_data.id == this.selectedCountry) {
  //         this.getListCity(_data.id);
  //       }
  //     }
  //     this.countries = list;
  //   });
  // }
  // end openActiveTemp
  closestampBoxStampAlert() {
    console.log(123123123123)
  }

  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  showPopupDownloadGurantee(template: TemplateRef<any>) {
    const created_time_val = $('#created_time').val();
    const listDate = created_time_val.toString().split(' - ');
    if (created_time_val) {
      if (listDate.length > 1) {
        const a = listDate[0].split('/');
        const resultFrom = a[2] + '-' + a[1] + '-' + a[0];
        const b = listDate[1].split('/');
        const resultTo = b[2] + '-' + b[1] + '-' + b[0];
        const resultFromDate = moment(`${resultFrom}`)
        const resultToDate = moment(`${resultTo}`)
        const validateResult = resultToDate.diff(resultFromDate, 'days') + 1
        console.log('validateResult', validateResult)
        if (validateResult > 31) {
          this.validateDownloadExcelPopup.show();
          return;
        } else {
          this.modalRef = this.modalService.show(template);
        }
      }
    } else {
      this.validateDownloadExcelPopup.show();
    }
    // this.modalRef = this.modalService.show(template);
    $('#exportGuarantee').select2({
      placeholder: 'Chọn danh mục cần tải',
    });
    this.getFieldGuarantee();
  }

  exportGuarantee() {
    $('.exportAlert').css('opacity', '0');
    // this.bsModalValidateDownloadExcelPopup = this.modalRef.show();
    // this.validateDownloadExcelPopup.show();
    const modelQuery = <any>{};
    const fields = <any>{}
    const arrField = $('#exportGuarantee').val();
    let listField = arrField ? arrField.join(',') : '';
    listField = listField.split(',')
    fields.fields = listField
    fields.sort = `ins_dt,${this.isSorting}`;
    if (this.model.serial) {
      fields.serial = this.model.serial;
    }
    if (this.model.sms) {
      fields.code = this.model.sms;
    }
    if (this.model.product) {
      fields.product = this.model.product;
    }
    const type = $('#type option:selected').text().trim();
    if (type != '') {
      const index = this.types.indexOf(type);
      if (index >= 0) {
        fields.type = this.typeValues[index];
      }
    }
    if (this.model.name) {
      fields.name = this.model.name;
    }
    if (this.model.phone) {
      fields.phone = this.model.phone;
    }
    if (this.productId) {
      fields.product_id = this.productId;
    }
    const created_time_val = $('#created_time').val();
    const listDate = created_time_val.toString().split(' - ');
    if (created_time_val) {
      if (listDate.length > 1) {
        const a = listDate[0].split('/');
        const resultFrom = a[2] + '-' + a[1] + '-' + a[0];
        const b = listDate[1].split('/');
        const resultTo = b[2] + '-' + b[1] + '-' + b[0];
        // const resultFromDate = moment(`${resultFrom}`)
        // const resultToDate = moment(`${resultTo}`)
        // const validateResult = resultToDate.diff(resultFromDate, 'days')
        // console.log('validateResult', validateResult)
        // if (validateResult > 30) {
        //   this.modalRef.hide();
        //   this.validateDownloadExcelPopup.show();
        //   return;
        // }
        fields.from = resultFrom;
        fields.to = resultTo;
      }
    }
    const agency_id = $('#distributionAgent').val();
    if (agency_id) {
      fields.agency_id = agency_id;
    }
    const status = $('#status option:selected').text().trim();
    if (status != '') {
      const index = this.type_list.indexOf(status) + 1;
      if (index > 0) {
        fields.status = index;
        if (index == 3 || index == 4 || index == 6) {
          fields.status = 2;
          fields.state = index;
        }
      }
    }
    modelQuery.exportTypeEnum = 'GUARANTEE';
    modelQuery.fields = fields;
    this.exportService.exportReport(modelQuery).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('HE_THONG_DANG_XU_LY');
        $('.exportAlert').css('opacity', '1');
        setTimeout(() => {
          $('.exportAlert').css('opacity', '0');
        }, 5000);
      } else {
        $('.exportAlert').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
    this.modalRef.hide();
  }

  closeModalValidateExport() {
    this.validateDownloadExcelPopup.hide();
  }

  printGuaranteeDetail() {
    console.log(this.logs_of_serial, this.serial_info)
    const data_logs = JSON.stringify(this.logs_of_serial);
    const data_serial = JSON.stringify(this.serial_info);
    const data_agency = JSON.stringify(this.agency_info);
    const data_serial_qri = JSON.stringify(this.qri_serial_detail);
    this.router.navigate(['/print-guarantee'], {
      queryParams: {
        data_logs_of_serial: data_logs,
        data_serial_infor: data_serial,
        data_agency_info: data_agency,
        data_serial_qri: data_serial_qri
      },
    });
  }

  public checkboxSingle: Boolean = false
  public checkboxStamps: Boolean = false
  public addContent: String = ''

  /** Tuanba: 20-9-2023: Thêm quét bằng thiết bị ngoại vi cho kích hoạt tem thùng **/
  changeCheckboxSingle() {
    this.checkboxSingle = $('#checkboxSingleBox').is(':checked')
    setTimeout(() => {
      $('#checkboxSingleBoxVal').focus()
    }, 100)
  }

  async changeCheckboxSingleValue() {
    let tmp = $('#checkboxSingleBoxVal').val();
    const contentBoxStamp = $('#serial_ids_box');
    tmp = tmp[0] + tmp.slice(1)
    $('#checkboxSingleBoxVal').val('')
    const check = contentBoxStamp.val().toUpperCase().split('\n');
    if (contentBoxStamp.val() !== '') {
      if (check.length >= 5) {
        this.toastr.error('Mã tem thùng không được qúa 5 tem', 'Thông báo', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
        return
      }
    }
    setTimeout(async () => {
      let id = '';
      if (tmp.search('http') !== -1 || tmp.search('Http') !== -1) {
        const splitLink = tmp.split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = tmp
      }

      if (id) {
        console.log('id', id)
        console.log('check', check)
        await this.boxStampDistributionService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              const data = val.data
              console.log('data.indexOf(check) ', check.indexOf(data))
              if (check.indexOf(data) !== 0) {
                if (contentBoxStamp.val() !== '') {
                  const line = contentBoxStamp.val() + '\n' + val.data
                  contentBoxStamp.val(`${line}`)
                  console.log('9a98989', contentBoxStamp.val())
                } else {
                  contentBoxStamp.val(`${val.data}`)
                }
              } else {
                console.log('123kkhasd')
              }
            } else {
              this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }

    }, 0);
    setTimeout(() => {
      $('#checkboxSingleBoxVal').focus()
    }, 100)


  }

  /** Tuanba: 21-9-2023: Thêm quét bằng thiết bị ngoại vi cho kích hoạt nhiều tem **/
  changeCheckboxStamps() {
    this.checkboxStamps = $('#checkboxStamps').is(':checked')
    setTimeout(() => {
      $('#checkboxStampsVal').focus()
    }, 100)
  }

  async changeCheckboxStampsValue() {
    let tmp = $('#checkboxStampsVal').val();
    const contentStamps = $('#serial_ids_stamps');
    tmp = tmp[0] + tmp.slice(1)
    $('#checkboxStampsVal').val('')
    const check = contentStamps.val().toUpperCase().split('\n');
    // if (contentStamps.val() !== '') {
    //   if (check.length >= 5) {
    //     this.toastr.error('Mã tem thùng không được qúa 5 tem', 'Thông báo', {
    //       timeOut: 4000,
    //       positionClass: 'toast-bottom-right'
    //     })
    //     return
    //   }
    // }
    setTimeout(async () => {
      let id = '';
      if (tmp.search('http') !== -1 || tmp.search('Http') !== -1) {
        const splitLink = tmp.split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = tmp
      }

      if (id) {
        console.log('id', id)
        console.log('check', check)
        await this.boxStampDistributionService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              const data = val.data
              console.log('data.indexOf(check) ', check.indexOf(data))
              if (check.indexOf(data) !== 0) {
                if (contentStamps.val() !== '') {
                  const line = contentStamps.val() + '\n' + val.data
                  contentStamps.val(`${line}`)
                  console.log('9a98989', contentStamps.val())
                } else {
                  contentStamps.val(`${val.data}`)
                }
              } else {
                console.log('123kkhasd')
              }
            } else {
              this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }

    }, 0);
    setTimeout(() => {
      $('#checkboxStampsVal').focus()
    }, 100)
  }

  /** Tuanba:13-3-2024: Import file **/
  @ViewChild('importFile') importFile: ModalDirective;

  openModalImportFile(event) {
    this.message = null;
    this.importFile.show();
  }

  closeModalImportFile() {
    this.importFile.hide();
  }

  public titleFile = 'Chọn file upload';
  public data_import_success: { class: string; content: string; } = null;
  public data_import_fail: { class: string; content: string; } = null;
  public files: any = null;

  onChange(event) {
    this.message = null;
    console.log('event', event)
    this.files = event.target.files;
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = 'Chọn file upload';
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  clearInputFile() {
    const input = $('#controlFileActiveGuarantee');
    input.wrap('<form>').closest('form').get(0).reset();
    input.unwrap();
  }

  submitForm(data) {
    // this.message = null;
    this.titleFile = 'Chọn file upload';

    if (this.files !== null && this.files.length > 0) {
      const file = this.files[0];
      this.files = null;
      const file_name = file.name;
      const allowedExtensions = ['xlsx', 'xls', 'csv'];
      const fileExtension = file_name.split('.').pop();
      if (this.isInArray(allowedExtensions, fileExtension)) {
        //msg process
        this.message = {
          class: 'alert dark alert-success',
          content: 'Đang thực hiện....'
        };
        //upload file
        this.upload2.uploadFileActiveGuarantee(file).then((res: any) => {
          console.log('ress', res)
          if (res.code === 1) {
            this.message = {
              class: 'alert dark alert-icon alert-success',
              content: 'Import sản file KHBH thành công !!',
            };
            this.toastr.success('Hệ thống đang thực hiện kích hoạt bảo hành cho sản phẩm, vui lòng xem kết quả ở mục Thông báo', '', {
              timeOut: 5000,
            });
            setTimeout(() => {
              this.currentPage = 1;
              this.getStasitic();
            }, 1000);
          } else {
            this.message = {
              class: 'alert dark alert-icon alert-danger',
              content: res.message
            }
              ;
          }
        }, error => {
          this.message = {
            class: 'alert dark alert-icon alert-danger',
            content: error.message
          };
        });
      } else {
        this.message = {
          class: 'alert alert-danger',
          content: 'Vui lòng chọn đúng file Excel.'
        };
      }
    } else {
      this.message = {
        class: 'alert alert-danger',
        content: 'Bạn chưa chọn file để Import.'
      };
    }
    this.clearInputFile()

  }

  getFileTemplete() {
    console.log('1212112122')
    this.stampService.getFileTemplete().subscribe((res) => {
      const url2 = window.URL.createObjectURL(res);
      console.log('url2', url2)
      const a2 = document.createElement('a');
      document.body.appendChild(a2);
      a2.href = url2;
      a2.download = 'File Mẫu' + '.xlsx';
      a2.click();
      window.URL.revokeObjectURL(url2);
    })

  }

}




// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/guarantee/logs-guarantee.component.ts